<!--@if (initialized) {-->
<!--    <form [formGroup]="blogPostForm" (ngSubmit)="submit()" class="p-fluid">-->
<!--        &lt;!&ndash; Outlet &ndash;&gt;-->
<!--        <div class="field">-->
<!--            <label for="outletId">Outlet</label>-->
<!--            <p-select-->
<!--                    formControlName="outletId"-->
<!--                    [options]="outlets"-->
<!--                    optionLabel="name"-->
<!--                    optionValue="id"-->
<!--                    [filter]="true"-->
<!--                    placeholder="Select outlet">-->
<!--            </p-select>-->
<!--            <small class="p-error"-->
<!--                   *ngIf="outletId?.touched && outletId?.invalid">-->
<!--                Outlet is required-->
<!--            </small>-->
<!--        </div>-->

<!--        &lt;!&ndash; Ghost Writer &ndash;&gt;-->
<!--        <div class="field">-->
<!--            <label for="writerId">Ghost Writer</label>-->
<!--            <p-select-->
<!--                    formControlName="writerId"-->
<!--                    [options]="ghostWriters"-->
<!--                    optionLabel="name"-->
<!--                    optionValue="id"-->
<!--                    [filter]="true"-->
<!--                    placeholder="Select writer">-->
<!--            </p-select>-->
<!--            <small class="p-error"-->
<!--                   *ngIf="writerId?.touched && writerId?.invalid">-->
<!--                Ghost writer is required-->
<!--            </small>-->
<!--        </div>-->

<!--        &lt;!&ndash; Topic &ndash;&gt;-->
<!--        <div class="field">-->
<!--            <label for="topic">Topic</label>-->
<!--            <input pInputText id="topic" type="text" formControlName="topic" placeholder="Enter topic"/>-->
<!--            <small class="p-error"-->
<!--                   *ngIf="topic?.touched && topic.hasError('required')">-->
<!--                Topic is required-->
<!--            </small>-->
<!--            <small class="p-error"-->
<!--                   *ngIf="topic?.touched && topic.hasError('minlength')">-->
<!--                Min 3 characters-->
<!--            </small>-->
<!--        </div>-->

<!--        <div class="mt-2 flex justify-content-end">-->
<!--            <button-->
<!--                    pButton-->
<!--                    type="submit"-->
<!--                    class="w-auto"-->
<!--                    label="Create"-->
<!--                    [icon]="busy ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"-->
<!--                    [disabled]="blogPostForm.invalid || busy"-->
<!--            >-->
<!--            </button>-->
<!--        </div>-->
<!--    </form>-->
<!--}-->



@if (initialized) {
    <form [formGroup]="blogPostForm" (ngSubmit)="submit()" class="p-fluid">
        <!-- Outlet -->
        <div class="field">
            <label for="outletId">Outlet</label>
            <p-select
                    formControlName="outletId"
                    [options]="outlets"
                    optionLabel="name"
                    optionValue="id"
                    [filter]="true"
                    placeholder="Select outlet">
            </p-select>
            <small class="p-error"
                   *ngIf="outletId?.touched && outletId?.invalid">
                Outlet is required
            </small>
        </div>

        <!-- Ghost Writer -->
        <div class="field">
            <label for="writerId">Ghost Writer</label>
            <p-select
                    formControlName="writerId"
                    [options]="ghostWriters"
                    optionLabel="name"
                    optionValue="id"
                    [filter]="true"
                    placeholder="Select writer">
            </p-select>
            <small class="p-error"
                   *ngIf="writerId?.touched && writerId?.invalid">
                Ghost writer is required
            </small>
        </div>

        <!-- Topic -->
        <div class="field">
            <label for="topic">Topic</label>
            <input pInputText id="topic" type="text" formControlName="topic" placeholder="Enter topic"/>
            <small class="p-error"
                   *ngIf="topic?.touched && topic.hasError('required')">
                Topic is required
            </small>
            <small class="p-error"
                   *ngIf="topic?.touched && topic.hasError('minlength')">
                Min 3 characters
            </small>
        </div>

        <div class="mt-2 flex justify-content-between">
            <!-- Create Blog Post-->
            <button
                    pButton
                    type="submit"
                    class="w-auto"
                    label="Auto Create"
                    [icon]="busy ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
                    [disabled]="blogPostForm.invalid || busy || promptText"
            >
            </button>
            <!-- Create Prompt-->
            <button
                    pButton
                    class="w-auto"
                    label="Create Prompt"
                    [icon]="busy ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
                    (click)="createPrompt()"
                    [disabled]="blogPostForm.invalid || busy || promptGenerated"
            >
            </button>
        </div>
        <!-- Prompt Output -->
        <div *ngIf="promptText" class="field mt-4">
            <label for="promptText">Generated Prompt</label>
            <textarea
                    pTextarea
                    id="promptText"
                    rows="8"
                    readonly
                    [value]="promptText"
                    class="w-full cursor-pointer"
                    (click)="copyPromptToClipboard()"
                    pTooltip="Click to copy"
                    tooltipPosition="top"
            >
            </textarea>
        </div>
        <!-- JSON Input Field -->
        <div *ngIf="promptGenerated" class="field mt-4">
            <label for="jsonInput">JSON Input</label>
            <textarea
                    pTextarea
                    id="jsonInput"
                    rows="6"
                    formControlName="json"
                    name="jsonInput"
                    class="w-full"
                    placeholder='Enter JSON'
            ></textarea>
            <small class="p-error"
                   *ngIf="json?.touched && json.hasError('required')">
                JSON is required
            </small>
            <small class="p-error"
                   *ngIf="json?.touched && json.hasError('minlength')">
                Min 3 characters
            </small>
        </div>

        <!-- Create Button below JSON -->
        <div *ngIf="promptGenerated" class="mt-2 flex justify-content-end">
            <button
                    pButton
                    type="button"
                    class="w-auto"
                    label="Create"
                    [icon]="busy ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
                    (click)="createFromJson()"
                    [disabled]="blogPostForm.invalid || busy">
            </button>
        </div>
    </form>
}

